import { tableController, translate } from 'magner';
import type { Address } from 'features/addresses/types/hubstr';

const addressesTable = tableController<Address>({
  emptyText: translate('hubstr.address.table.not_found'),
  rowLink: (row) => ({ name: 'address', params: { id: row.id } }),
  columns: [
    {
      prop: 'name',
      label: translate('hubstr.address.table.name'),
    },
    {
      prop: 'address',
      label: translate('hubstr.address.table.address'),
    },
    {
      prop: 'description',
      label: translate('hubstr.address.table.description'),
    },
  ],
});

export default addressesTable;
